import React from "react";

const InstagramTrueIcon = () => {
  return (
    <svg
    width={33}
    height={32}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 6.5H17.51M7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7C2 4.23858 4.23858 2 7 2ZM16 11.37C16.1234 12.2022 15.9813 13.0522 15.5938 13.799C15.2063 14.5458 14.5931 15.1514 13.8416 15.5297C13.0901 15.9079 12.2384 16.0396 11.4078 15.9059C10.5771 15.7723 9.80976 15.3801 9.21484 14.7852C8.61992 14.1902 8.22773 13.4229 8.09407 12.5922C7.9604 11.7616 8.09207 10.9099 8.47033 10.1584C8.84859 9.40685 9.45419 8.79374 10.201 8.40624C10.9478 8.01874 11.7978 7.87659 12.63 8C13.4789 8.12588 14.2649 8.52146 14.8717 9.12831C15.4785 9.73515 15.8741 10.5211 16 11.37Z"
      stroke="#000100"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x={15} y={14} width={18} height={18} rx={9} fill="#23A26D" />
    <path
      d="M22.4143 24.9722L27.8862 19.6871C28.0154 19.5624 28.1687 19.5 28.3463 19.5C28.5238 19.5 28.6772 19.5624 28.8063 19.6871C28.9354 19.8118 29 19.9599 29 20.1314C29 20.3029 28.9354 20.451 28.8063 20.5757L22.8662 26.3129C22.7371 26.4376 22.5864 26.5 22.4143 26.5C22.2421 26.5 22.0914 26.4376 21.9623 26.3129L19.186 23.6314C19.0568 23.5067 18.9949 23.3586 19.0003 23.1871C19.0057 23.0156 19.073 22.8675 19.2021 22.7428C19.3312 22.618 19.4846 22.5557 19.6621 22.5557C19.8397 22.5557 19.993 22.618 20.1222 22.7428L22.4143 24.9722Z"
      fill="white"
    />
  </svg>
  );
};

export default InstagramTrueIcon;
